import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <br />
    <h1 {...{
      "id": "disclaimer"
    }}>{`Disclaimer`}</h1>
    <p>{`This is a rewrite of the Massachusetts OEMS Protocols.
This is not created by Masschusetts OEMS, and is instead a different format of
reading and searching the protocols.`}</p>
    <br />
    <p>{`This rewrite is based off of:`}</p>
    <strong>
  Official Version 2020.1
  <br />
  Effective October 1, 2019
    </strong>
    <br /><br />
    <p>{`For the official Masschusetts OEMS Website `}<a parentName="p" {...{
        "href": "https://www.mass.gov/orgs/office-of-emergency-medical-services"
      }}>{`click here`}</a></p>
    <p>{`For the official PDF `}<a parentName="p" {...{
        "href": "https://www.mass.gov/doc/emergency-medical-services-pre-hospital-treatment-protocols-version-20201-effective-4120-pdf/download"
      }}>{`click here`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      